import { CarlineWithSalesgroups } from '../../types/vehicle-types';
import { externalContentManager } from '../external-content';
import { fetchCarlinesWithSalesgroups } from './fetch/data-fetch';
import {
	filterAvailableCarlinesForCurrentForm,
	filterCarlinesByMotorizacion,
	isCarlineAvailableForCurrentForm,
} from './helpers/carline-filters';

export const getCarline = async (nameOrCode?: string | number): Promise<CarlineWithSalesgroups | null> => {
	if (!nameOrCode) return null;

	const response = await fetchCarlinesWithSalesgroups();

	if (response) {
		const carline = response?.find((carline) => carline.name == nameOrCode || carline.code == nameOrCode);
		return carline && isCarlineAvailableForCurrentForm(carline) ? carline : null;
	}
	return null;
};

// Obtiene carlines desde carlineCode[] y carlineName[]
export const getCarlines = async (): Promise<CarlineWithSalesgroups[] | null> => {
	const carlines = await fetchCarlinesWithSalesgroups();
	if (!carlines) return null;

	const availableCarlines = filterAvailableCarlinesForCurrentForm(carlines);
	if (!availableCarlines) return null;

	const carlinesByMotorizacion = filterCarlinesByMotorizacion(availableCarlines);
	const carlinesToUse = carlinesByMotorizacion ? carlinesByMotorizacion : availableCarlines;

	const externalCarlines = externalContentManager.carlines;

	if (externalCarlines) {
		const configuredCarlines = carlinesToUse.filter(
			(carline) => externalCarlines.includes(carline.name) || externalCarlines.includes(String(carline.code)),
		);
		return configuredCarlines.length > 0 ? configuredCarlines : carlinesToUse;
	}

	return carlinesToUse;
};
